module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/75530645e4af177c82c6afff2bf3f7a8.png";